import {Injectable} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class IconService {
    private readonly icons: { name: string; path: string }[] = [
        {name: 'sat_icon', path: 'assets/icons/institutions/sat_icon.svg'},
        {name: 'imss_icon', path: 'assets/icons/institutions/imss_icon.svg'},
        {name: 'infonavit_icon', path: 'assets/icons/institutions/infonavit_icon.svg'}
    ];

    constructor(
        private readonly matIconRegistry: MatIconRegistry,
        private readonly domSanitizer: DomSanitizer
    ) {
    }

    public registerIcons(): void {
        this.icons.forEach((icon: {name: string; path: string}): void => {
            this.matIconRegistry.addSvgIcon(
                icon.name,
                this.domSanitizer.bypassSecurityTrustResourceUrl(icon.path)
            );
        });
    }
}
